import { useMemo, useState } from "react";
import { FilterPill, FilterPills } from "@/components/filters/filter-pills";
import { CandidateFilterPanel } from "@/components/filters/panels";
import { SearchAndFilterActions } from "@/components/filters/search-and-filter-actions";
import { useDebounce } from "@/hooks/use-debounce";
import { RecommendedCreatorsView } from "@/pages/collaborations/recommended-creators-view";
import { CANDIDATE_FILTER_FIELDS } from "@/pages/explorers/candidate-explorer";
import { toRecommendationsFilters } from "@/pages/explorers/recommendations-filters";
import { FiltersProvider, useFilters } from "@/providers/filter-provider";

const CandidateReviewMatchesContent = () => {
  const { apiFilters, hasActiveFilters } = useFilters();
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search);
  const [filtersOpen, setFiltersOpen] = useState(false);

  const trimmedSearch = search.trim();
  const searchPill = trimmedSearch ? (
    <FilterPill label="Search" value={trimmedSearch} onRemove={() => setSearch("")} />
  ) : undefined;

  const filters = useMemo(() => toRecommendationsFilters(apiFilters, debouncedSearch), [apiFilters, debouncedSearch]);

  return (
    <>
      <RecommendedCreatorsView
        mode="explorer"
        explorerType="candidate"
        filters={filters}
        isFiltered={hasActiveFilters || !!debouncedSearch}
        filterControls={
          <>
            <SearchAndFilterActions
              search={search}
              onSearchChange={setSearch}
              onToggleFilters={() => setFiltersOpen((prev) => !prev)}
              searchClassName="flex-1"
            />
            <FilterPills extraPills={searchPill} />
          </>
        }
      />
      <CandidateFilterPanel open={filtersOpen} close={() => setFiltersOpen(false)} clearAll={() => setSearch("")} />
    </>
  );
};

export const CandidateReviewMatches = () => (
  <FiltersProvider activeFields={[...CANDIDATE_FILTER_FIELDS]}>
    <CandidateReviewMatchesContent />
  </FiltersProvider>
);
